import { TbLogout, TbUserFilled } from 'react-icons/tb';
import type { MobileNavigationAccount } from './types';
import SignOutForm from './SignOutForm';

interface AccountActionsProps {
  account: MobileNavigationAccount;
}

export default function AccountActions({ account }: AccountActionsProps) {
  return (
    <div className="bio-mobile-menu__account">
      {account.kind === 'signedOut' ? (
        <>
          <a className="bio-mobile-menu__button" href={account.signIn}>
            <TbUserFilled size={14} className="bio-mobile-menu__button-icon" />
            Login
          </a>
          <a
            className="bio-mobile-menu__button bio-mobile-menu__button--primary"
            href={account.register}
          >
            Create an Account
          </a>
        </>
      ) : (
        <>
          {account.settings && (
            <a
              className="bio-mobile-menu__button bio-mobile-menu__button--primary"
              href={account.settings}
            >
              <TbUserFilled
                size={14}
                className="bio-mobile-menu__button-icon"
              />
              Account Settings
            </a>
          )}
          <SignOutForm {...account.signOut}>
            <button type="submit" className="bio-mobile-menu__button">
              Logout
              <TbLogout
                size={14}
                className="bio-mobile-menu__button-icon bio-mobile-menu__button-icon--end"
              />
            </button>
          </SignOutForm>
        </>
      )}
    </div>
  );
}
